import { render, staticRenderFns } from "./UrlUpload.vue?vue&type=template&id=39933da8&scoped=true&"
import script from "./UrlUpload.vue?vue&type=script&lang=js&"
export * from "./UrlUpload.vue?vue&type=script&lang=js&"
import style0 from "./UrlUpload.vue?vue&type=style&index=0&id=39933da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39933da8",
  null
  
)

export default component.exports